import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../../../react-core/Flux/Dispatcher";
import { RegularPaymentInstructionStatic } from "./RegularPaymentInstructionStatic";
import { ExistingRegularPaymentsStatic } from "./ExistingRegularPaymentsStatic";
import { ExistingIndexationsStatic } from "./ExistingIndexationsStatic";

export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
}

export const RegularPaymentInstructionDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const RegularPaymentInstructionStore: RegularPaymentInstructionStatic = new RegularPaymentInstructionStatic();

export const ExistingRegularPaymentsDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const ExistingRegularPaymentsStore: ExistingRegularPaymentsStatic = new ExistingRegularPaymentsStatic();

export const ExistingIndexationsDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const ExistingIndexationsStore: ExistingIndexationsStatic = new ExistingIndexationsStatic();
